<template>
  <van-popup v-model:show="data.show" round>
    <div class="container">
      <div class="pay_popup">
        <p>{{ $t('other.special_offer') }}</p>
        <!--    倒计时    -->
        <div class="expire_in">
          <Countdown :title="$t('other.expire_in')" :duration="10 * 60"></Countdown>
        </div>
        <!--    金币变动    -->
        <div class="got_it_btn">
          <img src="~/assets/images/other/icon-other-sp-o-coin.png" alt="">
          <span class="percent_span">+{{ data.extraData?.gift_coin_percent }}</span>
          <div class="coin_num">
            <div>
              <span>{{ data.extraData?.coin }}</span>
              <span>{{ $t('reader.coins') }}</span>
            </div>
            <img src="~/assets/images/other/icon-other-coin-close.png" alt="">
            <div>
              <span>{{ data.extraData?.gift_coin }}</span>
              <span>{{ $t('reader.coins') }}</span>
            </div>
          </div>
          <div class="btn_box" @click="handlePay">
            <img src="~/assets/images/other/icon-other-btn-bg.png" alt="">
            <div v-if="data.extraData?.discount_price" class="btn_text">
              <span>${{ data.extraData?.discount_price }}</span>
              <span>${{ data.extraData?.price }}</span>
            </div>
            <div v-else class="btn_text">
              <span>${{ data.extraData?.price }}</span>
            </div>
          </div>
        </div>
        <img class="icon_w" src="~/assets/images/other/icon-other-sp-o.png" alt="">
        <img class="icon_l" src="~/assets/images/reader/icon-reader-light.png" alt="">
        <img class="icon_c" src="~/assets/images/reader/icon-reader-popup-close.png" alt="" @click="closePopup">
      </div>
    </div>
  </van-popup>
</template>

<script setup lang="ts">
import {reactive} from 'vue'
const emit = defineEmits(['handlePay','close'])
const data = reactive({
  show: false,
  extraData: {}
})

const closePopup = () => {
  data.show = false
  emit('close')
  eventBus.emit('reload_after_close')
}
const open = (extraData) => {
  data.show = true
  data.extraData = extraData
}

const handlePay = () =>{
  emit('handlePay','PayPopup', data.extraData)
}

defineExpose({
  open,
})
</script>

<style scoped lang="scss">
.van-popup {
  background: transparent;

}

.container {
  position: relative;
  height: 500px;
  display: flex;
  justify-content: center;
  align-items: center;

  .pay_popup {
    width: 312px;
    aspect-ratio: 1200 / 800; /* 背景图原始宽高比，容器高度自适应 */
    background: url('~/assets/images/other/icon-other-sp-o-bg.png');
    background-size: 100% auto; /* 宽度铺满，高度按原比例等比缩放，不压缩不拉伸 */
    background-repeat: no-repeat;
    background-position: center top; /* 靠上显示 */
    position: relative;
    border-radius: 21px;
    padding: 21px 0 0;


    p {
      text-align: center;
      font-style: normal;
      font-family: 'SFPro', 'SFPro';
      font-weight: bold;
      font-size: 23px;
      color: #FF4965;
      line-height: 28px;
      background: linear-gradient(0deg, #FF7749 0%, #FF0F73 100%);
      -webkit-background-clip: text; /* 关键：裁剪背景到文字 */
      -webkit-text-fill-color: transparent; /* 让文字本身透明 */
    }

    .icon_w {
      position: absolute;
      left: 50%;
      top: -92px;
      width: 252px;
      transform: translateX(-50%);
    }

    .icon_l {
      position: absolute;
      left: 50%;
      top: -98px;
      width: 281px;
      transform: translateX(-50%);
      z-index: -1;
    }

    .icon_c {
      position: absolute;
      left: 50%;
      top: calc(100% + 21px);
      width: 25px;
      transform: translateX(-50%);
      height: 25px;
    }

    .expire_in {
      font-family: 'SFPro', 'SFPro';
      font-weight: 500;
      font-size: 14px;
      color: #32343A;
      line-height: 16px;
      font-style: normal;
      margin-top: 13px;
      display: flex;
      justify-content: center;
    }

    .got_it_btn {
      width: 100%;
      border-radius: 23px;
      position: relative;

      .percent_span {
        font-family: 'SFPro', 'SFPro';
        font-weight: bold;
        font-size: 12px;
        color: #FFFFFF;
        line-height: 15px;
        text-align: center;
        font-style: normal;
        position: absolute;
        /* 黄色斜条带主段平行四边形中心在图内的固定比例位置：x = 1016.5/1200, y = 108.5/744，随图等比缩放始终对准 */
        left: calc(87% + 1px);
        top: 17.9%;
        transform: translate(-50%, -50%) rotate(45deg); /* 先让元素中心对准斜条带中心，再旋转 45° */
      }

      .coin_num {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 36px;
        position: absolute;
        top: 29px;

        div {
          display: flex;
          flex-direction: column;
          align-items: center;

          span {
            &:first-child {
              font-family: D-DIN-PRO, D-DIN-PRO;
              font-weight: bold;
              font-size: 26px;
              color: #FFFFFF;
              line-height: 31px;
              text-align: right;
              font-style: normal;
            }

            &:last-child {
              font-family: 'SFPro', 'SFPro';
              font-weight: 500;
              font-size: 14px;
              color: rgba(255, 255, 255, 0.8);
              line-height: 16px;
              text-align: right;
              font-style: normal;
            }
          }
        }

        img {
          width: 19px;
          height: 19px;
        }
      }

      .btn_box {
        position: absolute;
        bottom: 12px;
        display: flex;
        justify-content: center;

        img {
          width: 94%;
        }

        .btn_text {
          width: 100%;
          font-family: 'SFPro', 'SFPro';
          font-weight: bold;
          font-size: 20px;
          color: #FFFFFF;
          line-height: 23px;
          font-style: normal;
          position: absolute;
          top: 22px;
          display: flex;
          justify-content: center;
          align-items: flex-end;
          gap: 3px;
          transform: translateY(-1px);

          span {
            &:nth-child(2) {
              font-family: 'SFPro', 'SFPro';
              font-weight: 400;
              font-size: 14px;
              color: rgba(255, 255, 255, 0.8);
              line-height: 20px;
              font-style: normal;
              text-decoration-line: line-through;
            }
          }
        }
      }

      img {
        width: 100%;
        display: block;
      }
    }

    .btn_group {
      width: 100%;

      img {
        width: 100%;
      }
    }
  }
}

</style>
